import HeroBanner from './components/HeroBanner';
import FeaturedSection from './components/FeaturedSection';
import CategoryPreview from './components/CategoryPreview';
import NewArrivals from './components/NewArrivals';
import FAQSection from './components/FAQSection';
import { allMovies } from '@/mocks/movies';

const statsData = [
  { label: '影视资源', value: `${allMovies.length}+`, unit: '部', icon: 'ri-movie-2-line' },
  { label: '高清画质', value: '1080P', unit: '', icon: 'ri-4k-line' },
  { label: '每日更新', value: '50+', unit: '部', icon: 'ri-refresh-line' },
  { label: '满意用户', value: '1000万+', unit: '', icon: 'ri-user-heart-line' },
];

export default function Home() {
  const schemaWebPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '番茄影视 - 首页',
    description: '番茄影视大全一站式汇聚海量影视资源，覆盖电影、电视剧、综艺、动漫等全类型片库',
    url: 'https://www.fanqieyingshi.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '番茄影视',
      url: 'https://www.fanqieyingshi.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(schemaWebPage)}
      </script>

      <main>
        <HeroBanner />

        <section className="w-full px-4 md:px-6 py-8 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {statsData.map((stat, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-4 rounded-lg bg-background-50"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                    <i className={`${stat.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <div>
                    <div className="flex items-baseline gap-0.5">
                      <span className="text-lg font-bold text-foreground-950">{stat.value}</span>
                      {stat.unit && <span className="text-xs text-foreground-500">{stat.unit}</span>}
                    </div>
                    <p className="text-xs text-foreground-500">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <FeaturedSection />
        <CategoryPreview />
        <NewArrivals />
        <FAQSection />
      </main>
    </>
  );
}